import React, { useRef, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { Key, Mail, ArrowRight, CheckCircle } from "lucide-react";

import { data, Link, useNavigate } from "react-router-dom";

import Password from "./Password";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import axios from "axios";

const ChangePassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const code = useRef();
  const navigate = useNavigate();

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const form = event.currentTarget;

  //   if (form.checkValidity() === false) {
  //     event.stopPropagation();
  //     setValidated(true);
  //     return;
  //   }

  //   setIsLoading(true);
  //   await new Promise((resolve) => setTimeout(resolve, 1500));
  //   setIsLoading(false);
  //   setIsSubmitted(true);
  // };

  // const resetForm = () => {
  //   setIsSubmitted(false);
  //   setEmail("");
  //   setValidated(false);
  // };

const resetPassword = async () => {
  if (!email) return;

  const formData = new FormData();
  formData.append("email", email);
  localStorage.setItem("userEmail", email);

  try {
    const res = await axios.post(
      "https://skillsuprise.com/reset-password-otp.php",
      formData,
      SecurityHeaders
    );

    console.log("OTP RESPONSE:", res.data[0]);

    if (res?.data[0]?.status === "success") {
     setPassword(true);
          setPhone(res.data[0].phone);
      localStorage.setItem("userPhone",res.data[0].phone);
      
      window.location.replace("/otp-page");
    }
  } catch (error) {
    console.error("OTP error:", error);
  }
};

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        position: "relative",
        overflow: "hidden",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      }}
    >
      {/* Floating Background Elements */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            top: "5rem",
            left: "5rem",
            width: "8rem",
            height: "8rem",
            background:
              "linear-gradient(135deg, rgba(60, 7, 185, 0.2) 0%, rgba(54, 0, 141, 0.2) 100%)",
            animationDelay: "0s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            top: "10rem",
            right: "8rem",
            width: "6rem",
            height: "6rem",
            background:
              "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%)",
            animationDelay: "1s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            bottom: "8rem",
            left: "8rem",
            width: "7rem",
            height: "7rem",
            background:
              "linear-gradient(135deg, rgba(168, 85, 247, 0.2) 0%, rgba(236, 72, 153, 0.2) 100%)",
            animationDelay: "2s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            bottom: "5rem",
            right: "5rem",
            width: "9rem",
            height: "9rem",
            background:
              "linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)",
            animationDelay: "3s",
          }}
        ></div>

        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              width: "0.75rem",
              height: "0.75rem",
              background:
                "linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(168, 85, 247, 0.3) 100%)",
              borderRadius: "50%",
              filter: "blur(2px)",
              animation: "pulse 3s ease-in-out infinite",
              top: `${10 + ((i * 7) % 80)}%`,
              left: `${5 + ((i * 11) % 90)}%`,
              animationDelay: `${i * 200}ms`,
              animationDuration: `${2000 + i * 100}ms`,
            }}
          />
        ))}
      </div>

      <Container
        fluid
        style={{
          position: "relative",
          zIndex: 10,
          padding: "2rem 1rem",
        }}
      >
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} sm={10} md={8} lg={6} xl={4}>
            {!password ? (
              <Card
                style={{
                  background: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "1.5rem",
                  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <Card.Body className="p-4 p-md-5">
                  <div className="text-center mb-4">
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <div
                        style={{
                          width: "4rem",
                          height: "4rem",
                          background:
                            "linear-gradient(135deg, #405189, #405189)",
                          borderRadius: "1.5rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 10px 25px rgba(139, 92, 246, 0.3)",
                          transform: "rotate(12deg)",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          position: "relative",
                          zIndex: 2,
                        }}
                      >
                        <Key size={32} className="text-white" />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          inset: "-0.5rem",
                          background:
                            "linear-gradient(135deg, #405189, #405189)",
                          borderRadius: "1.5rem",
                          filter: "blur(20px)",
                          opacity: 0.3,
                          animation: "pulse 3s ease-in-out infinite",
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="text-center mb-4">
                    <h1
                      style={{
                        fontSize: "2rem",
                        fontWeight: 700,
                        color: "#1e293b",
                        marginBottom: "1rem",
                        letterSpacing: "-0.025em",
                      }}
                    >
                      Forgot password?
                    </h1>
                    <p
                      style={{
                        color: "#64748b",
                        fontSize: "0.875rem",
                        lineHeight: 1.6,
                        marginBottom: 0,
                      }}
                    >
                      Forgot Password ? Quickly Reset Your Password
                      <br />
                      shortly.
                    </p>
                  </div>

                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={ resetPassword}
                  >
                    <Form.Group className="mb-4">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#374151",
                          marginBottom: "0.5rem",
                          fontSize: "1.100rem",
                        }}
                      >
                        Email
                      </Form.Label>
                      <div style={{ position: "relative" }}>
                        <Mail
                          style={{
                            position: "absolute",
                            left: "1rem",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9ca3af",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            zIndex: 2,
                          }}
                          size={20}
                        />
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{
                            padding: "1rem 1rem 1rem 3rem",
                            border: "1px solid #e5e7eb",
                            borderRadius: "1.5rem",
                            background: "rgba(248, 250, 252, 0.5)",
                            backdropFilter: "blur(10px)",
                            fontSize: "1rem",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            borderColor:
                              validated && !email ? "#dc3545" : "#374151",
                            boxShadow:
                              validated && !email
                                ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
                                : "0 0 0 0.2rem rgba(139, 92, 246, 0.1)",
                            background:
                              validated && !email
                                ? "rgba(255, 255, 255, 0.8)"
                                : "rgba(248, 250, 252, 0.5)",
                          }}
                          required
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{
                            display: validated && !email ? "block" : "none",
                            fontSize: "0.875rem",
                            color: "#dc3545",
                          }}
                        >
                          Please provide a valid email address.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <div className="text-center">
                      <Button
                        onClick={resetPassword}
                        type="button"
                        style={{
                          // background:
                          //   "linear-gradient(135deg, #374151, #374151)",
                          border: "none",
                          borderRadius: "1.5rem",
                          padding: "1rem 1.5rem",
                          fontWeight: 600,
                          fontSize: "1rem",
                          boxShadow: "0 10px 25px rgba(139, 92, 246, 0.3)",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          position: "relative",
                          overflow: "hidden",
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                          transform: isLoading ? "none" : "translateY(0)",
                          ":hover": !isLoading
                            ? {
                                boxShadow:
                                  "0 15px 35px rgba(139, 92, 246, 0.4)",
                                transform: "translateY(-2px)",
                              }
                            : {},
                        }}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <div
                              style={{
                                display: "inline-block",
                                width: "1.25rem",
                                height: "1.25rem",
                                border: "2px solid #ffffff",
                                borderRadius: "50%",
                                borderTopColor: "transparent",
                                animation: "spin 1s linear infinite",
                                marginRight: "0.5rem",
                              }}
                            />
                            Sending...
                          </>
                        ) : (
                          <>
                            Reset password
                            <ArrowRight
                              size={20}
                              style={{ marginLeft: "0.5rem" }}
                            />
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>

                  <div className="text-center mt-4">
                    <Link to="/login" style={{ textDecoration: "none" }}>
                      <Button
                        variant="link"
                        style={{
                          color: "#64748b",
                          textDecoration: "none",
                          fontWeight: 500,
                          fontSize: "0.875rem",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          border: "none",
                          background: "none",
                          padding: 0,
                          ":hover": { color: "#374151" },
                        }}
                      >
                        Back to login
                      </Button>
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            ) : (
              <Password
                email={email}
                userPhone={phone}
                password={password}
              ></Password>
            )}
          </Col>
        </Row>
      </Container>

      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.015,
          pointerEvents: "none",
          backgroundImage:
            "radial-gradient(circle at 1px 1px,#374151) 1px, transparent 0)",
          backgroundSize: "20px 20px",
        }}
      ></div>
    </div>
  );
};

export default ChangePassword;
